/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledTooltip } from "reactstrap";
import { Disc, FileText, Briefcase, AlignJustify, Inbox } from "react-feather";
import { BlurSpinner } from "../../../components/BlurSpinner";
import Sucursal from "./Sucursal";
import Nominas from "./Nominas";
import Facturacion from "./Facturacion";
import Cobranzas from "./Cobranzas";
import useFetcher from "../../../hooks/useFetcher";
import { fetchSubclient } from "../../../services/subclientesServices";
import { handleErrors } from "../../../services/handleErrors";

const ModalTabs = ({ subclientId }) => {
  const [activeTab, setActiveTab] = useState("1");
  const [subclientData, setSubclientData] = useState(null);
  const [changesToSave, setChangesToSave] = useState(false);
  const [isLoadingAreas, setIsLoadingAreas] = useState(true);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const ClientId = urlParams.get("clientId");

  const areaFinder = (id) => {
    const data = subclientData && subclientData.areas.find((area) => area.type === id);
    return data;
  };

  const isCentralized = (id) => {
    const data = subclientData && subclientData.areas.find((area) => area.type === id);
    if (data && data.centralizado !== null) {
      return data.centralizado;
    }
    return false;
  };

  const handleChangesToSave = (value) => {
    setChangesToSave(value);
  };
  useEffect(async () => {
    try {
      const data = await fetchSubclient(subclientId);
      setSubclientData(data);
      setIsLoadingAreas(false);
    } catch (error) {
      handleErrors(error);
    }
  }, []);

  return (
    <>
      <BlurSpinner isLoading={isLoadingAreas}>
        <Nav tabs className="border-tab nav-primary justify-content-between mb-2">
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink
              className={`${activeTab === "1" ? "active" : ""} px-2`}
              style={{ display: "grid", cursor: "pointer", color: `${activeTab === "1" ? "#962b20" : "#777d84"}` }}
              onClick={() => setActiveTab("1")}
              disabled={activeTab !== "1" && changesToSave}
            >
              <span>
                <Briefcase width="32px" height="32px" />
              </span>
              <small style={{ fontSize: "16px" }}>Sucursal</small>
              {isCentralized(1) ? <Disc width="16px" height="16px" style={{ color: "#D2766B", margin: "auto" }} /> : <span style={{ height: "16px" }} />}
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink
              className={`${activeTab === "2" ? "active" : ""} px-2`}
              style={{ display: "grid", cursor: "pointer", color: `${activeTab === "2" ? "#962b20" : "#777d84"}` }}
              onClick={() => setActiveTab("2")}
              disabled={activeTab !== "2" && changesToSave}
            >
              <span>
                <AlignJustify width="32px" height="32px" />
              </span>
              <small style={{ fontSize: "16px" }}>Nóminas </small>
              {isCentralized(2) ? <Disc width="16px" height="16px" style={{ color: "#D2766B", margin: "auto" }} /> : <span style={{ height: "16px" }} />}
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink
              className={`${activeTab === "3" ? "active" : ""} px-2`}
              style={{ display: "grid", cursor: "pointer", color: `${activeTab === "3" ? "#962b20" : "#777d84"}` }}
              onClick={() => setActiveTab("3")}
              disabled={activeTab !== "3" && changesToSave}
            >
              <span>
                <Inbox width="32px" height="32px" />
              </span>
              <small style={{ fontSize: "16px" }}>Facturación</small>
              {isCentralized(3) ? <Disc width="16px" height="16px" style={{ color: "#D2766B", margin: "auto" }} /> : <span style={{ height: "16px" }} />}
            </NavLink>
          </NavItem>
          <NavItem className="nav nav-tabs" role="tablist">
            <NavLink
              className={`${activeTab === "4" ? "active" : ""} px-2`}
              style={{ display: "grid", cursor: "pointer", color: `${activeTab === "4" ? "#962b20" : "#777d84"}` }}
              onClick={() => setActiveTab("4")}
              disabled={activeTab !== "4" && changesToSave}
            >
              <span>
                <FileText width="32px" height="32px" />
              </span>
              <small style={{ fontSize: "16px" }}>Cobranzas</small>
              {isCentralized(4) ? <Disc width="16px" height="16px" style={{ color: "#D2766B", margin: "auto" }} /> : <span style={{ height: "16px" }} />}
            </NavLink>
          </NavItem>
        </Nav>
        {subclientData && (
          <TabContent activeTab={activeTab} className="p-0">
            <TabPane tabId="1">
              <Sucursal
                centralizado={isCentralized(1)}
                ClientId={ClientId}
                subClient={subclientData}
                subclientAreaData={areaFinder(1)}
                handleChangesToSave={handleChangesToSave}
              />
            </TabPane>
            <TabPane tabId="2">
              <Nominas centralizado={isCentralized(2)} ClientId={ClientId} subclientAreaData={areaFinder(2)} handleChangesToSave={handleChangesToSave} />
            </TabPane>
            <TabPane tabId="3">
              <Facturacion
                centralizado={isCentralized(3)}
                ClientId={ClientId}
                subClient={subclientData}
                subclientAreaData={areaFinder(3)}
                handleChangesToSave={handleChangesToSave}
              />
            </TabPane>
            <TabPane tabId="4">
              <Cobranzas centralizado={isCentralized(4)} ClientId={ClientId} subclientAreaData={areaFinder(4)} handleChangesToSave={handleChangesToSave} />
            </TabPane>
          </TabContent>
        )}
      </BlurSpinner>
    </>
  );
};

export default ModalTabs;
